import { TW_CheckboxFilterValueEditor, TW_CheckboxFilterValueEditor_not_selected, TW_CheckboxFilterValueEditor_Wrapper } from "@utils/twClasses";
import Field from "@dto/fields";
import { CheckSquare, Square } from "lucide-react";


type CheckboxFilterValueEditorProps = {
    field: Field | null;
    value: any;
    disabled: boolean;
    onValueChange: (value: any) => void;
}

export function CheckboxFilterValueEditor({ value, onValueChange }: CheckboxFilterValueEditorProps) {

    function onClick(event: React.MouseEvent<HTMLDivElement>) {
        event.preventDefault();
        event.stopPropagation();
        const newValue = !value;
        onValueChange(newValue);
    }

    return (
        <div className={TW_CheckboxFilterValueEditor_Wrapper} onClick={onClick} >
            {value ?
                <CheckSquare tabIndex={-1} className={TW_CheckboxFilterValueEditor} aria-label="Check value" />
                :
                <Square tabIndex={-1} className={TW_CheckboxFilterValueEditor_not_selected} aria-label="Uncheck value"/>
            }
        </div>
    )
}